import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
/**
 * Iframe element isolated for DI purposes
 */
export const IFrame = ({
  childRef,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("iframe", _extends({}, props, {
    ref: childRef
  }));
};